/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Listing_RightInputs */

const en_directory_comparison_product_hunt_rows_listing_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Listing_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A launch post and community discussion`)
};

const zh_directory_comparison_product_hunt_rows_listing_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Listing_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布帖子与社区讨论`)
};

/**
* | output |
* | --- |
* | "A launch post and community discussion" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Listing_RightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_listing_right = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Listing_RightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Listing_RightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_listing_right(inputs)
	return zh_directory_comparison_product_hunt_rows_listing_right(inputs)
});
export { directory_comparison_product_hunt_rows_listing_right as "directory.comparison.product_hunt.rows.listing.right" }